export const SERVICE_HIGHLIGHT_MS = 4000;
